<template>
    <div>
        <b-alert v-model="showWarningAlert" variant="warning" dismissible>
            {{ reminder }}
        </b-alert>
        <div v-if="toonSelectie" class="form-inline mx-0 px-0 my-0 py-0">
            <b-input-group :prepend="giveNaam" style="width: 50%">
                <b-form-select
                    v-model="partijID"
                    @change="set_inputPartij"
                    :disabled="!editAllowed"
                    v-bind:class="{ tc_aux_highlighted: warnForStockAmount }"
                >
                    <template #first>
                        <b-form-select-option value=""
                            >--
                            {{
                                $t('com_selecteer', {
                                    ns: 'common'
                                })
                            }}
                            --</b-form-select-option
                        >
                    </template>
                    <option
                        v-for="option in itemStockList"
                        :value="option.value"
                        :key="option.value"
                        v-bind:class="{ tc_aux_highlighted: option.warn }"
                    >
                        {{ option.text }}
                    </option>
                </b-form-select>
            </b-input-group>

            <b-input-group
                style="width: 20%"
                append=""
                :label="$t('com_amount', { ns: 'common' })"
            >
                <b-form-input
                    :placeholder="$t('com_amount', { ns: 'common' })"
                    type="number"
                    step="1"
                    v-model.number="hoeveelheid"
                    :style="
                        localSelected.isNew
                            ? localSelected.isChanged
                                ? ''
                                : {
                                      'background-color': '#33FF90',
                                      color: '#33FF90'
                                  }
                            : ''
                    "
                    @change="set_input"
                    :disabled="!editAllowed"
                ></b-form-input>
            </b-input-group>

            <lookup-combo
                style="width: 15%"
                v-model="eenheid"
                v-bind:combotype="lctypeUnits"
                v-bind:discrim="localSelected.eenheid.toString()"
                :disabled="!editAllowed"
                @change="set_input"
            ></lookup-combo>

            <b-button
                style="width: 5%"
                @click="addBatch()"
                class="bgc_aux_normal"
                :disabled="!editAllowed"
                ><font-awesome-icon icon="arrow-down" size="1x" />
            </b-button>
        </div>
        <div v-else>{{ nostockstring }}</div>
    </div>
</template>
<script>
import { IngredientElement } from '../../models/Recept';
import Helper from '../../models/Helper';
import DateHelper from '../../models/DateHelper';
import { loadItem, loadList } from '../../models/DataHelper';
import { Permission } from '../../models/Permissions';
import { Feature } from '../../models/Features';
import { LookupCombo } from '../components';
export default {
    name: 'PrepIngredientCombo',
    data: function () {
        return {
            lctypeUnits: window.constants.LCPERUNITS,
            showWarningAlert: false,
            reminder: '',
            errorMessage: '',
            partijID: null,
            eenheid: null,
            hoeveelheid: null,
            flexList: [],
            warnAmount: false,
            selectedIsSet: false,
            selectedRadio: 'silo',
            detailsVisible: false,
            rerenderkey: 1,
            withPrepend: true
        };
    },
    props: {
        element: {
            type: IngredientElement,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        setSelected: {
            type: String
        }
    },
    components: {
        LookupCombo
    },
    watch: {},
    computed: {
        localSelected() {
            return this.element;
        },
        warnForStockAmount() {
            return this.warnAmount;
        },
        itemStockList() {
            const tempList = this.flexList.map((x) => {
                const tekst = x.datum
                    ? Helper.stringformat(
                          '{0} (' +
                              this.$t('com_tht', { ns: 'common' }) +
                              ': {1})',
                          x.batchID,
                          DateHelper.convertedToDateShort(x.datum)
                      )
                    : x.batchID;
                return {
                    value: x.id,
                    text: tekst,
                    warn: x.waarschuwen
                };
            });

            return tempList;
        },
        toonSelectie() {
            return this.itemStockList.length > 0;
        },
        giveNaam() {
            return this.withPrepend ? this.localSelected.naam : '';
        },
        nostockstring() {
            return Helper.stringformat(
                '{0}: {1}',
                this.giveNaam,
                this.$t('com_createstock', { ns: 'common' })
            );
        }
    },
    methods: {
        showReminder(tekst) {
            this.reminder = tekst;
            this.showWarningAlert = true;
        },
        reset() {
            this.detailsVisible = false;
            this.$parent.$emit('production_refresh');
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-itemBakInfo');
            });
        },
        findPartijID(batchID) {
            let partijID = '';
            const stockItem = this.flexList.find((x) => x.batchID == batchID);
            if (stockItem) partijID = stockItem.id;
            return partijID;
        },
        findPartijNummer(partijID) {
            let partijnummer = '';
            const stockItem = this.flexList.find((x) => x.id == partijID);
            if (stockItem) partijnummer = stockItem.batchID;
            return partijnummer;
        },
        findPartijAmount(partijID) {
            let hh = 0;
            const stockItem = this.flexList.find((x) => x.id == partijID);
            if (stockItem) hh = stockItem.aantal;
            return hh;
        },
        async set_inputPartij() {
            const stockItem = this.flexList.find((x) => x.id == this.partijID);
            const hh = stockItem ? stockItem.aantal : 0;
            this.warnAmount = hh < 0;
            if (stockItem?.datum) {
                const dagen = DateHelper.dateDiffinDays(
                    stockItem.datum,
                    new Date()
                );
                if (dagen < 0) {
                    const message = this.$t('prod_overtht', {
                        ns: 'production',
                        val: DateHelper.convertedToDate(stockItem.datum)
                    });
                    this.showReminder(message);
                }
            }
            this.localSelected.partijID = this.partijID;
            this.localSelected.partijNummer = this.findPartijNummer(
                this.partijID
            );
            this.set_input();
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_input() {
            this.localSelected.isChanged = true;
        },
        addBatch() {
            const eenheid = this.$store.getters['components/getUnitbyID'](
                this.eenheid
            );
            this.$emit('input', {
                productID: this.localSelected.product,
                productName: this.localSelected.naam,
                stockID: this.partijID,
                batchNumber: this.findPartijNummer(this.partijID),
                unitID: this.eenheid,
                unit: eenheid?.naam,
                amount: this.hoeveelheid,
                isNew: true
            });
        }
    },
    mounted() {},
    async created() {
        const prodID = this.localSelected.product;
        if (prodID == 1) {
            // water, even stock inschieten
            const water = await loadItem(
                'stock/loadStockItem',
                { stockitemid: this.localSelected.product },
                this.$t
            );
            this.flexList.push(water);
            this.partijID = water.id;
            this.set_inputPartij();
        } else {
            const locList = await loadList(
                'product/getStockItemLijst',
                'stock/loadStockByProduct',
                { productid: prodID },
                true,
                this.$t
            );
            if (locList.length > 0) {
                const dezelfde = prodID == locList[0].productID;
                if (dezelfde) {
                    this.flexList = locList;
                    this.partijID =
                        this.localSelected.partijID ??
                        (this.itemStockList.length > 0
                            ? this.itemStockList[0].value
                            : null);
                    this.set_inputPartij();
                }
            }
        }
        if (this.localSelected.eenheid == undefined) {
            this.localSelected.eenheid = this.$store.getters[
                'components/getUnitIDbyName'
            ](this.localSelected.eenheidNaam);
        }
        this.eenheid = this.localSelected.eenheid;
        this.hoeveelheid = this.localSelected.hoeveelheid;
    }
};
</script>

<style scoped></style>
